<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
    <div class="call-to-action">
      <SmartLinkElement
        :codename="contentTypes.hero.elements.title.codename"
      >
        <MyLink :to="href" class="btn btn-primary" :target="linkTarget">
          {{ model.elements.linkTitle.value }}
        </MyLink>
      </SmartLinkElement>
    </div>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import { contentTypes } from '~/models'
import type { CallToActionModel } from '~/models'
import { useCtaLink } from '~/composables/useCtaLink'
const props = defineProps<{ model: CallToActionModel }>()
const href = computed(() => useCtaLink(props.model))
const linkTarget = computed(() => getLinkTarget(false, href.value))
</script>
